import { type Interceptor } from '@connectrpc/connect';
import { requestSink } from '../request-sink';

/**
 * The sink is used to prevent any API calls from being made. They will be thrown into the sink and won't be processed.
 *
 * Important: This interceptor should be the first one in the chain, so that it can prevent any API calls from being processed.
 */
export const sinkInterceptor: Interceptor = (next) => (req) => requestSink.pipe(() => next(req));
